import { DataModelCommonConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/data-model-common/model-id-type-converter';
import { ElementBaseSdkTypeV3 } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { DeepPartial } from 'ts-essentials';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { DataType, DeltaOf, IDataModel } from '@tencent/slide-sdk-model';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { GroupPropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/group-property-converter';
import { ShapePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/shape-property-converter';
import { PicturePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/picture-property-converter';
import { ConnectorPropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/connector-property-converter';
import { TablePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/table-property-converter';
import { TableCellPropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/table-cell-property-converter';
import { SectionPropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/section-property-converter';
import { ChartPropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/chart-property-converter';
import { ADD_ON_MODE_MAP } from '@src/slide/domain/ui-model/converter/node-property/sdk-ui-enum-map/data-type';
import { SmartArtPropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/smart-art-property-converter';

const getConverterByUiType = function (
    uiType: UIModelType,
    inTable?: boolean,
) {
    const convertMap = {
        [UIModelType.GROUP]: GroupPropertyConverter,
        [UIModelType.SHAPE]: inTable ? TableCellPropertyConverter : ShapePropertyConverter,
        [UIModelType.IMAGE]: PicturePropertyConverter,
        [UIModelType.CONNECTOR]: ConnectorPropertyConverter,
        [UIModelType.TABLE]: TablePropertyConverter,
        [UIModelType.SECTION]: SectionPropertyConverter,
        [UIModelType.CHART]: ChartPropertyConverter,
        [UIModelType.SMART_ART]: SmartArtPropertyConverter,
    };
    return convertMap[uiType] || null;
};

export default class ModelConverterBridge {
    public static convertSdkToUi({ type, sdkData, uiData }: {
        type: UIModelType,
        sdkData: DeepPartial<ElementBaseSdkTypeV3>,
        uiData: IBaseModel,
    }): IBaseModel {
        const converter = getConverterByUiType(type, (uiData as IShapeModel).inTable);
        if (converter) {
            DataModelCommonConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
            converter.convertPartialDataFromSdkToUi(
                sdkData?.props || sdkData, // 单元格时sdkData.props是空的
                uiData,
                uiData.changeSetEngine?.changesetInfo,
            );
        }
        return uiData;
    }

    public static convertUiToSdk({ type, sdkData, uiData, rawUiData }: {
        type: UIModelType,
        sdkData: DeltaOf<IDataModel>,
        uiData: IBaseModel,
        rawUiData: IPictureModel | IShapeModel | ITableModel
    }): void {
        const converter = getConverterByUiType(type, (rawUiData as IShapeModel).inTable);
        if (converter) {
            DataModelCommonConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
            converter.convertPartialDataFromUiToSdk(uiData, sdkData, rawUiData);
        }
    }

    public static getUiTypeBySdkType(sdkType: DataType): UIModelType {
        return ADD_ON_MODE_MAP.get(sdkType) ?? UIModelType.SHAPE;
    }
}
